module.exports = __webpack_public_path__ + "static/Placeholder_Karakter-Mobile-254a9ee0939f78aa6355aebed3a910d6.png";